import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
const getToken = () => localStorage.getItem("token");

export const getPartners = async ({ offset = 1, limit = 10, status = "", search = "" } = {}) => {
    return axios.get(`${API_BASE_URL}/admin/partners`, {
        params: { offset, limit, status, search },
        headers: { token: getToken() },
    });
};

export const deletePartnerById = async (id, body) => {
    return axios.delete(`${API_BASE_URL}/admin/partners/${id}`, {
        headers: { token: getToken() },
        data: body,
    });
};

export const getPartnerById = async (id) => {
    return axios.get(`${API_BASE_URL}/admin/partners/${id}`, {
        headers: { token: getToken() },
    });
};

export const updatePartnerStatus = async (partnerId, status, reason = "") => {
    return axios.get(`${API_BASE_URL}/auth/partner-status`, {
        params: { partnerId, status, reason },
        headers: { token: getToken() },
    });
};

export const getPrivateFileBlob = async (filename) => {
    return axios.get(`${API_BASE_URL}/upload/private-file/${filename}`, {
        headers: { token: getToken() },
        responseType: "blob",
    });
};

export const updatePartnershipContractStatus = (partnerId, status, reason, serviceType) => {
    return axios.get(`${API_BASE_URL}/auth/partnership-contract-status`, {
        params: {
            partnerId, status, reason, serviceType
        },
        headers: { token: getToken() },
    });
}